import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiCreateUserBadgeRequestBody,
  IApiCreateUserBadgeResponseBody,
} from '../UserBadgesApi.types';
import { useApi } from '~/lib/api/useApi';
import { userBadgeQueryKeyFactory } from './useUserBadgeQuery';
import { userBadgesQueryKeyFactory } from './useUserBadgesQuery';

export type IUseCreateUserBadgeMutationValues = {
  appId: string;
  body: IApiCreateUserBadgeRequestBody;
};

export const useCreateUserBadgeMutation = (): UseMutationResult<
  IApiCreateUserBadgeResponseBody,
  unknown,
  IUseCreateUserBadgeMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: IUseCreateUserBadgeMutationValues) =>
      api.userBadges.create(values.appId, values.body),
    onSuccess: async (createdUserBadge) => {
      queryClient.setQueryData(
        userBadgeQueryKeyFactory({
          appId: createdUserBadge.userBadge.appId,
          userBadgeId: createdUserBadge.userBadge._id,
        })!,
        createdUserBadge,
      );
      await queryClient.invalidateQueries({
        queryKey: userBadgesQueryKeyFactory({
          appId: createdUserBadge.userBadge.appId,
        }),
      });
    },
  });
};
